/**
 * @props id - Unique id for the tooltip. ID is important for tooltip to work.  (string)
 * @props text: Text that we want to show inside tooltip (string)
**/

import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import styles from "./TxTooltip.styles"
import "./directcss/TxTooltip.scss"
import General from '../../../libs/utility/General';

const TxTooltip = ({ id = "", text = "", customTooltipstyles = {} }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <>
            <Tooltip
                placement="top"
                isOpen={tooltipOpen}
                target={id}
                toggle={toggle}
                className="custom-tooltip"
                style={{...styles.tooltipBackground, ...customTooltipstyles}}
            >
                <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(text) }} />
            </Tooltip>
        </>
    );
}

export default TxTooltip;
